import { documentTypes as defaultDocumentTypes } from "../template/pdf"

import { customPdfConfigs } from '../customization/pdf'

export const getPdfConfigs = () => {

  let documentTypes = defaultDocumentTypes; // use system default

  // getting custom pdf configs
  // console.log('customPdfConfigs', customPdfConfigs)

  if (Object.keys(customPdfConfigs).length > 0) {

    // remain the default - and override the custom configs
    documentTypes = {
      ...documentTypes,
      ...customPdfConfigs
    }

    // console.log('documentTypes', documentTypes)

  }

  return {
    documentTypes
  }

}